import { Component, OnInit } from '@angular/core';
import { BpgMembershipService } from '../bpg-membership.service';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { DataService, membershipFormData, leadership, LandingDTOModel, FilterModel } from "../../bpg-common/services/data.services";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-bpg-membership-preview',
  templateUrl: './bpg-membership-preview.component.html',
  styleUrls: ['./bpg-membership-preview.component.css']
})
export class BpgMembershipPreviewComponent implements OnInit {

  bpg: any[] = [];
  skills: any[] = [];
  areaOfImpact: any[] = [];
  formData: membershipFormData[];
  firstCategory: any[] = [];
  secondCategory: any[] = [];
  thirdCategory: any[] = [];
  demographics: any[] = [];
  savedData: any;
  selectedSite: any;
  selectedBpg: any[] = [];
  selectedInterest: any[] = [];
  selectedSkills: any[] = [];
  selectedDemographics: any[] = [];
  chair: boolean;
  voiceChair: boolean;
  communicationsChair: boolean;
  financeChair: boolean;
  otherSKills: string = "";
  membershipDetails: any[] = [];
  message: String;

  selectedLeadership: leadership = new leadership();
  finalFormdata: finalFormdata[] = [];

  areaOfImpactIdsArray: number[] = [];
  bpgIdsArray: number[] = [];
  //demographicIdsArray: number[] = [];
  isLeadershipChecked: leadershipFormObject = new leadershipFormObject();
  skillIdsArray: number[] = [];
  userId: number = 1;
  otherSkills: string = "";
  alertSuccess: boolean;
  loginData: any;
  loginUserId: any[] = [];
  memberDetails: any;
  savedMembershipForm: any;
  msg1: string;
  msg2: string;
  previewMethod: string;
  landingDTOModel: LandingDTOModel = new LandingDTOModel();
  filter: FilterModel = new FilterModel();
  siteId1: any = localStorage.getItem('userSiteId');
  status: any;
  defaultSiteLocation = '';
  virtualBpg: boolean;
  siteId: number;
  bpgList : any; 
  chairs :  any = [];
  viceChairs : any = []  ;
  communicationsChairs: any= [] ;
  financeChairs: any  = [];
  corporateType: string;
  isCorporateUser: boolean = false;

  public DisableSkills: boolean = true;
  public DisableBpg: boolean = true;
  public DisableLeadership: boolean = true;
  public DisableAreaOfImpact: boolean = true;
  public DisableDemographics: boolean = true;
  public checked: boolean = false;

  /** @class BpgMembershipPreviewComponent
* @constructor
*/
  constructor(private membershipService: BpgMembershipService,
    private bpgcommonService: BpgCommonService,
    private data: DataService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    
    private environment: EnvironmentConfiguration
  ) { }

  ngOnInit() {
    if (this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod') {
              if (localStorage.getItem('loginData')== null || localStorage.getItem('loginData')== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.corporateType = (this.loginData.corporatePartnerType !== null && this.loginData.corporatePartnerType !== undefined) ? this.loginData.corporatePartnerType.trim() : '';
    if (this.corporateType.toUpperCase() == "CONTINGENT" || this.corporateType.toUpperCase() == "TECHNICAL CONTRACTOR") {
      this.isCorporateUser = true;
    }
    // console.log(this.loginData.userId);
    this.memberDetails = this.loginData;
    // this.filter.siteId= this.siteId1 ;
    // this.landingDTOModel.filter = this.filter;

    this.loginUserId = this.loginData.userId;
    this.defaultSiteLocation = this.loginData.site.siteName;
    // this.bpgcommonService.getUserDetails(this.loginUserId).subscribe(data => {
    //   console.log(data);
    //   this.memberDetails = data;
    // })

    // this.data.savedMembershipForm.subscribe(savedMembershipForm => this.savedMembershipForm = savedMembershipForm)

    // this.data.savedData.subscribe(savedData => this.savedData = savedData)
    this.savedMembershipForm = JSON.parse(sessionStorage.getItem('previousMembershipDetails'));
    this.savedData = JSON.parse(sessionStorage.getItem('MembershipData'));
    this.formData = [];
    this.getBpgDetails();

    this.membershipService.getSkills().subscribe(data => {
      this.skills = data;

      if (this.savedData[0].skillsFormData != undefined) {
        if (this.savedData[0].skillsFormData.length > 0) {
          for (let i = 0, len = this.skills.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].skillsFormData.length; j < len; j++) {
              if (this.skills[i].skillId == this.savedData[0].skillsFormData[j].skillId) {
                this.skills[i].checked = true;
                this.selectedSkills.push(this.skills[i]);
              }
            }
          }
        }
        else if (localStorage.getItem('oneSkill') == 'true') {
          if (this.savedMembershipForm.otherSkills != this.savedData[0].otherSkillsFormData) {
            this.otherSKills = this.savedData[0].otherSkillsFormData;
          } else {
            this.otherSKills = this.savedMembershipForm.otherSkills;
          }
          this.selectedSkills.push(this.savedData[0].skillsFormData);
        }
        else if (this.savedMembershipForm.skillIds.length > 0) {
          if (this.savedMembershipForm.otherSkills != null) {
            this.otherSKills = this.savedMembershipForm.otherSkills;
          }
          for (let i = 0, len = this.skills.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.skillIds.length; j < len; j++) {
              if (this.skills[i].skillId == this.savedMembershipForm.skillIds[j]) {
                this.skills[i].checked = true;
                this.selectedSkills.push(this.skills[i]);
              }
            }
          }
        }
        else if (this.savedMembershipForm.otherSkills != null) {
          this.otherSKills = this.savedMembershipForm.otherSkills;
        }
      }

    })
    this.status = localStorage.getItem('status');
    this.membershipService.getAreasOfImpact().subscribe(data => {
      this.areaOfImpact = data;

      var groupByName = {};
      this.areaOfImpact.forEach(function (a) {
        groupByName[a.category] = groupByName[a.category] || [];
        groupByName[a.category].push({ areaOfImpactId: a.areaOfImpactId, subCategory: a.subCategory });

      });

      this.firstCategory = groupByName["Work Force Inclusion"];
      this.secondCategory = groupByName["Work Place Engagement"];
      this.thirdCategory = groupByName["Market Place Connection"];
      if (this.savedData[0].interestFormData != undefined) {
        if (this.savedData[0].interestFormData.length > 0) {
          for (let i = 0, len = this.firstCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].interestFormData.length; j < len; j++) {
              if (this.firstCategory[i].areaOfImpactId == this.savedData[0].interestFormData[j].areaOfImpactId) {
                this.firstCategory[i].checked = true;
                this.selectedInterest.push(this.firstCategory[i]);
              }
            }
          }
          for (let i = 0, len = this.secondCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].interestFormData.length; j < len; j++) {
              if (this.secondCategory[i].areaOfImpactId == this.savedData[0].interestFormData[j].areaOfImpactId) {
                this.secondCategory[i].checked = true;
                this.selectedInterest.push(this.secondCategory[i]);
              }
            }
          }

          for (let i = 0, len = this.thirdCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].interestFormData.length; j < len; j++) {
              if (this.thirdCategory[i].areaOfImpactId == this.savedData[0].interestFormData[j].areaOfImpactId) {
                this.thirdCategory[i].checked = true;
                this.selectedInterest.push(this.thirdCategory[i]);
              }
            }
          }
        }
        else if (this.savedData[0].interestFormData.length == 0 && this.status == 'true') {
          for (let i = 0, len = this.firstCategory.length; i < len; i++) {
            this.firstCategory[i].checked = false;
          }
          for (let i = 0, len = this.secondCategory.length; i < len; i++) {
            this.secondCategory[i].checked = false;
          }
          for (let i = 0, len = this.thirdCategory.length; i < len; i++) {
            this.thirdCategory[i].checked = false;
          }
        }
        else if (this.savedMembershipForm.areaOfImpactIds.length > 0) {
          for (let i = 0, len = this.firstCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.areaOfImpactIds.length; j < len; j++) {
              if (this.firstCategory[i].areaOfImpactId == this.savedMembershipForm.areaOfImpactIds[j]) {
                this.firstCategory[i].checked = true;
                this.selectedInterest.push(this.firstCategory[i]);
              }
            }
          }
          for (let i = 0, len = this.secondCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.areaOfImpactIds.length; j < len; j++) {
              if (this.secondCategory[i].areaOfImpactId == this.savedMembershipForm.areaOfImpactIds[j]) {
                this.secondCategory[i].checked = true;
                this.selectedInterest.push(this.secondCategory[i]);
              }
            }
          }
          for (let i = 0, len = this.thirdCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.areaOfImpactIds.length; j < len; j++) {
              if (this.thirdCategory[i].areaOfImpactId == this.savedMembershipForm.areaOfImpactIds[j]) {
                this.thirdCategory[i].checked = true;
                this.selectedInterest.push(this.thirdCategory[i]);
              }
            }
          }
        }
      }

    })
    //demographic code comment
    // this.membershipService.getDemographics().subscribe(data => {
    //   this.demographics = data;

    //   if (this.savedData[0].demographicsFormData != undefined) {
    //     if (this.savedData[0].demographicsFormData.length > 0) {
    //       for (let i = 0, len = this.demographics.length; i < len; i++) {
    //         for (let j = 0, len = this.savedData[0].demographicsFormData.length; j < len; j++) {
    //           if (this.demographics[i].demograhicId == this.savedData[0].demographicsFormData[j].demograhicId) {
    //             this.demographics[i].checked = true;
    //             this.selectedDemographics.push(this.demographics[i]);
    //           }
    //         }
    //       }
    //     }
    //     else if(this.savedMembershipForm.demographicIds.length>0){
    //       for (let i = 0, len = this.demographics.length; i < len; i++) {
    //         for (let j = 0, len = this.savedMembershipForm.demographicIds.length; j < len; j++) {
    //           if (this.demographics[i].demograhicId == this.savedMembershipForm.demographicIds[j]) {
    //             this.demographics[i].checked = true;
    //             this.selectedDemographics.push(this.demographics[i]);
    //           }
    //         }
    //       }
    //     }
    //   }
    // })
    this.chair = null;
    this.voiceChair = null;
    this.communicationsChair = null;
    this.financeChair = null;

    if (this.savedData[0].leadershipFormData != undefined) {
      if (this.savedData[0].leadershipFormData.chair != undefined) {
        this.chair = this.savedData[0].leadershipFormData.chair;
      }
      if (this.savedData[0].leadershipFormData.viceChair != undefined) {
        this.voiceChair = this.savedData[0].leadershipFormData.viceChair;
      }
      if (this.savedData[0].leadershipFormData.communicationsChair != undefined) {
        this.communicationsChair = this.savedData[0].leadershipFormData.communicationsChair;
      }
      if (this.savedData[0].leadershipFormData.financeChair != undefined) {
        this.financeChair = this.savedData[0].leadershipFormData.financeChair;
      }
    }
    else if (this.savedMembershipForm.leadershipDetails != null) {
      this.chair = this.savedMembershipForm.leadershipDetails.isChair;
      this.voiceChair = this.savedMembershipForm.leadershipDetails.isViceChair;
      this.communicationsChair = this.savedMembershipForm.leadershipDetails.isCommunicationChair;
      this.financeChair = this.savedMembershipForm.leadershipDetails.isFinanceChair;

    }

    if (this.savedData[0].otherSkillsFormData != undefined) {
      this.otherSKills = this.savedData[0].otherSkillsFormData;
    } else {
      this.otherSKills = null;
    }
    //console.log(JSON.stringify(this.otherSKills));
  }

  /** to select the checkbox
   * @class BpgMembershipPreviewComponent
   * @method toggleCheckboxBpg
   */
  toggleCheckboxBpg(event, data) {  
    
    if (event.target.checked) {
      this.selectedBpg.push(data);
      for (var i = 0 ; i < this.bpg.length ; i++)
      {
 
       if( this.bpg[i].bpgName == data.bpgName)
       {
         this.bpg[i] = Object.assign(this.bpg[i], {
           'showLeadership' : true,
         })
     
 }}
    
      for(var j = 0 ; j < this.selectedBpg.length ; j++)
      {
        if( this.selectedBpg[j].bpgName == data.bpgName){
          this.selectedBpg[j] = Object.assign(this.selectedBpg[j], {
            chairs : false,communicationsChairs: false , financeChairs :false, viceChairs : false
  })
        }
      }
     
 
   } else {
      const index: number = this.selectedBpg.indexOf(data);
      if (index !== -1) {
      

        this.selectedBpg.splice(index, 1);
       for (var i = 0; i < this.bpg.length ; i++){
        if(this.bpg[i].bpgName == data.bpgName)
        {
         this.bpg[i] = Object.assign(this.bpg[i], {
            'showLeadership' : false,
      }) }
   
     
      }
     
      }
    }

//     if (event.target.checked) {
//       this.selectedBpg.push(data);
     
//    for (var i = 0 ; i < this.bpg.length ; i++)
//      {

//       if( this.bpg[i].bpgName == data.bpgName)
//       {
//         this.bpg[i] = Object.assign(this.bpg[i], {
//           chairs : null,communicationsChairs: null , financeChairs :null , viceChairs : null
           
//         })
//        this.bpg[i] = Object.assign(this.bpg[i], {
//           'showLeadership' : true,
// })
// }}
   
//    } else {
//       const index: number = this.selectedBpg.indexOf(data);

//       for (var i = 0; i < this.bpg.length ; i++){
//         if(this.bpg[i].bpgName == data.bpgName)
//         {
//          this.bpg[i] = Object.assign(this.bpg[i], {
//             'showLeadership' : false,
//       }) }  }
   
//       if (index !== -1) {
        
//         this.selectedBpg.splice(index, 1);
      
     
//       }
     
    
//     }

  }

  /** to select the checkbox
   * @class BpgMembershipPreviewComponent
   * @method toggleCheckboxAreaOfImpact
   */
  toggleCheckboxAreaOfImpact(event, data) {
    if (event.target.checked) {
      this.selectedInterest.push(data);

    } else {
      const index: number = this.selectedInterest.indexOf(data);
      if (index !== -1) {
        this.selectedInterest.splice(index, 1);
      }
    }

  }

  /** to select cancel
    * @class BpgMembershipPreviewComponent
    * @method cancelClick
    */
  cancelClick() {
    localStorage.setItem('status', 'false');
    this.previewMethod = "navigate";
    this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
  }

  /** to select confirm
    * @class BpgMembershipPreviewComponent
    * @method saveClick
    */
  saveClick() {
    localStorage.setItem('status', 'false');
    localStorage.setItem('oneSkill', 'false');
    this.previewMethod = "saveMembershipForm";
    this.msg1 = " Do you want to submit Membership form ?";
  }

  navigate() {
    this.router.navigate(['membership']);
    sessionStorage.removeItem("MembershipData");

    window.scrollTo(0, 0);
  }

  assignroles(event,data)

  {
    var bpgName = data.bpgName;
    if(event.target.checked)
    {
      for (var i = 0 ; i < this.selectedBpg.length ; i++)
      {
        if(bpgName = this.selectedBpg[i].bpgName)
        {
        if(this.chairs[bpgName])
        this.selectedBpg[i].chairs = true;
        if(this.viceChairs[bpgName])
        this.selectedBpg[i].viceChairs = true;
        if(this.communicationsChairs[bpgName])
        this.selectedBpg[i].communicationsChairs = true;
        if(this.financeChairs[bpgName])
        this.selectedBpg[i].financeChairs = true;
        }
      }
    }
    
    else{
      for (var i = 0 ; i < this.selectedBpg.length ; i++)
      {
        if(bpgName = this.selectedBpg[i].bpgName)
        {
        if(!this.chairs[bpgName])
        this.selectedBpg[i].chairs = false;
        if(!this.viceChairs[bpgName])
        this.selectedBpg[i].viceChairs = false;
        if(!this.communicationsChairs[bpgName])
        this.selectedBpg[i].communicationsChairs = false;
        if(!this.financeChairs[bpgName])
        this.selectedBpg[i].financeChairs = false;
        }
      }
     
    }
    console.log(this.selectedBpg)
    }
// {
// var bpgName = data.bpgName;
// for (var i = 0 ; i < this.selectedBpg.length ; i++)
// {
//   if(bpgName == this.selectedBpg[i].bpgName)
//   {
 

// if(this.chairs[bpgName])
// this.selectedBpg[i].chairs = true;
// if(this.chairs[bpgName] == false)
// this.selectedBpg[i].chairs = false;
// if(this.chairs[bpgName] == null)
// this.selectedBpg[i].chairs = null;
// if(this.viceChairs[bpgName])
// this.selectedBpg[i].viceChairs = true;
// if(this.viceChairs[bpgName] ==  false)
// this.selectedBpg[i].viceChairs = false;
// if(this.viceChairs[bpgName] ==  null)
// this.selectedBpg[i].viceChairs = null;
// if(this.communicationsChairs[bpgName])
// this.selectedBpg[i].communicationsChairs = true;
// if(this.communicationsChairs[bpgName]== false)
// this.selectedBpg[i].communicationsChairs = false;
// if(this.communicationsChairs[bpgName] ==  null)
// this.selectedBpg[i].communicationsChairs = null;
// if(this.financeChairs[bpgName])
// this.selectedBpg[i].financeChairs = true;
// if(this.financeChairs[bpgName]== false)
// this.selectedBpg[i].financeChairs = false;
// if(this.financeChairs[bpgName]==null)
// this.selectedBpg[i].financeChairs = null; 
// }
// }

// }
  /** to select the checkbox
  * @class BpgMembershipPreviewComponent
  * @method toggleCheckboxSkill
  */
  toggleCheckboxSkill(event, data) {
    if (event.target.checked) {
      this.selectedSkills.push(data);

    } else {
      const index: number = this.selectedSkills.indexOf(data);
      if (index !== -1) {
        this.selectedSkills.splice(index, 1);
      }
    }

  }
  /** To async the service call to get the bpg list with selected bpgs
   * @class BpgMembershipPreviewComponent
   * @method getBpgDetails
   */
  getBpgDetails() {
    if (this.savedData[0].virtualBpg && this.defaultSiteLocation != 'DFLT') {
      this.getVirtualBpgs();
    } else {
      this.getBpgs();
    }
  }

  /** To async the service call to get the bpg list
   * @class BpgMembershipPreviewComponent
   * @method getBpgs
   */
  getBpgs() {
    if (this.savedData[0].siteFormData != undefined) {
      this.selectedSite = this.savedData[0].siteFormData;
      this.filter.siteId = String(this.selectedSite.siteId);
      this.landingDTOModel.filter = this.filter;
    }
    this.membershipService.getAllBpg(this.landingDTOModel).subscribe(data => {
      this.bpg = data;
      this.getSelectedBpgs();
    });
  }

  /** To async the service call to get the bpg list of default site
   * @class BpgMembershipPreviewComponent
   * @method getBpgs
   */
  getVirtualBpgs() {
    if (this.savedData[0].siteFormData != undefined) {
      this.selectedSite = this.savedData[0].siteFormData;
      this.filter.siteId = String(this.selectedSite.siteId);
    }
    const params = `${this.filter.siteId}/${this.siteId1}/${this.loginData.userId}`;
    console.info(params);
    this.membershipService.getAllVirtualBpg(params).subscribe(data => {
      this.bpg = data;
      this.getSelectedBpgs();
    });
  }


  /** To async the service call to get the selected bpg list
   * @class BpgMembershipPreviewComponent
   * @method getSelectedBpgs
   */
  getSelectedBpgs() {
    if (this.savedData[0].bpgFormData != undefined) {
      if (this.savedData[0].bpgFormData.length > 0) {
        for (let i = 0, len = this.bpg.length; i < len; i++) {
          for (let j = 0, len = this.savedData[0].bpgFormData.length; j < len; j++) {
            if (this.bpg[i].bpgId == this.savedData[0].bpgFormData[j].bpgId) {
              this.bpg[i].checked = true;
              this.bpg[i].showLeadership = true;
              this.bpg[i].chairs = this.savedData[0].bpgFormData[j].chairs;
              this.chairs[this.bpg[i].bpgName] =  this.bpg[i].chairs;
              this.bpg[i].viceChairs = this.savedData[0].bpgFormData[j].viceChairs;
              this.viceChairs[this.bpg[i].bpgName] =  this.bpg[i].viceChairs;
              this.bpg[i].communicationsChairs = this.savedData[0].bpgFormData[j].communicationsChairs;
              this.communicationsChairs[this.bpg[i].bpgName] =  this.bpg[i].communicationsChairs;
              this.bpg[i].financeChairs = this.savedData[0].bpgFormData[j].financeChairs;
              this.financeChairs[this.bpg[i].bpgName] =  this.bpg[i].financeChairs;
              this.selectedBpg.push(this.bpg[i]);
              console.log(this.selectedBpg)
            }
          }
        }
      }
    }
  }


// this.selectedBpg[i].chair = null;
// if(this.viceChair[bpgName])
// this.selectedBpg[i].viceChair = true;
// if(this.viceChair[bpgName] ==  false)
// this.selectedBpg[i].viceChair = false;
// if(this.viceChair[bpgName] ==  null)
// this.selectedBpg[i].viceChair = null;
// if(this.communicationsChair[bpgName])
// this.selectedBpg[i].communicationsChair = true;
// if(this.communicationsChair[bpgName]== false)
// this.selectedBpg[i].communicationsChair = false;
// if(this.communicationsChair[bpgName] ==  null)
// this.selectedBpg[i].communicationsChair = null;
// if(this.financeChair[bpgName])
// this.selectedBpg[i].financeChair = true;
// if(this.financeChair[bpgName]== false)
// this.selectedBpg[i].financeChair = false;
// if(this.financeChair[bpgName]==null)
// this.selectedBpg[i].financeChair = null; 


  //demographic code comment
  /** to select the checkbox
   * @class BpgMembershipPreviewComponent
   * @method toggleCheckboxDemo
   */
  // toggleCheckboxDemo(event, data) {
  //   if (event.target.checked) {
  //     this.selectedDemographics.push(data);

  //   } else {
  //     const index: number = this.selectedDemographics.indexOf(data);
  //     if (index !== -1) {
  //       this.selectedDemographics.splice(index, 1);
  //     }
  //   }
  // }



  /**
    * // To disable or to enable selected division
    * @class BpgMembershipPreviewComponent
    * @method changeFun
    */

  public changeFun(type) {
    switch (type) {
      case 'DisableLeadership': this.DisableLeadership = false;
        break;
      case 'DisableBpg': this.DisableBpg = false;
        break;
      case 'DisableSkills': this.DisableSkills = false;
        break;
      case 'DisableAreaOfImpact': this.DisableAreaOfImpact = false;
        break;
      //demograpic code comment
      // case 'DisableDemographics': this.DisableDemographics = false;
      //   break;
    }
  }

  /** to save all selected data
   * @class BpgMembershipPreviewComponent
   * @method saveMembershipForm
   */
  saveMembershipForm() {
    // if (this.selectedBpg.length < 1) {
    //   this.message = "*Please select atleast one BPG";
    //   return
    // }
    this.spinnerService.show();
    this.selectedLeadership.chair = this.chair;
    this.selectedLeadership.viceChair = this.voiceChair;
    this.selectedLeadership.communicationsChair = this.communicationsChair;
    this.selectedLeadership.financeChair = this.financeChair;

    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.selectedSite, bpgFormData: this.selectedBpg, interestFormData: this.selectedInterest, skillsFormData: this.selectedSkills, leadershipFormData: this.selectedLeadership, otherSkillsFormData: this.otherSKills })
    //demographic code comment
    //this.formData.push({ bpgFormData: this.selectedBpg, interestFormData: this.selectedInterest, skillsFormData: this.selectedSkills, leadershipFormData: this.selectedLeadership, demographicsFormData: this.selectedDemographics, otherSkillsFormData: this.otherSKills})

    this.virtualBpg = this.formData[0].virtualBpg;
    this.siteId = this.formData[0].siteFormData.siteId;
    this.formData[0].bpgFormData.forEach(bpg => {
      this.bpgIdsArray.push(bpg.bpgId)
    });
    this.formData[0].interestFormData.forEach(interest => {
      this.areaOfImpactIdsArray.push(interest.areaOfImpactId);
    });
    //demographic code comment
    // this.formData[0].demographicsFormData.forEach(demo => {
    //   this.demographicIdsArray.push(demo.demograhicId);
    // });
    this.formData[0].skillsFormData.forEach(skills => {
      this.skillIdsArray.push(skills.skillId);
    });

    this.isLeadershipChecked.isChair = this.formData[0].leadershipFormData.chair;
    this.isLeadershipChecked.isViceChair = this.formData[0].leadershipFormData.viceChair;
    this.isLeadershipChecked.isCommunicationChair = this.formData[0].leadershipFormData.communicationsChair;
    this.isLeadershipChecked.isFinanceChair = this.formData[0].leadershipFormData.financeChair;
    this.otherSKills = this.formData[0].otherSkillsFormData;
   for(var i = 0; i < this.selectedBpg.length; i++)
   {
     this.selectedBpg[i].createdBy = this.loginUserId;
     this.selectedBpg[i].modifiedBy = this.loginUserId;
   }
    this.finalFormdata.push({
      areaOfImpactIds: this.areaOfImpactIdsArray, bpgIds: this.bpgIdsArray,
      //demographicIds: this.demographicIdsArray, //demographic code comment
      skillIds: this.skillIdsArray, isLeadershipChecked: this.isLeadershipChecked,
      otherSkill: this.otherSKills, userId: this.loginUserId,
      siteId: this.siteId, virtualMembership: this.virtualBpg,
      selectedBpg : this.selectedBpg
    });
    console.log(this.selectedBpg)

    this.membershipService.saveMembershipForm(this.finalFormdata[0]).subscribe(data => {
      //console.log(data);
      setTimeout(function () {
        this.spinnerService.hide();
        this.router.navigate(['/membership/preview-success']);
      }.bind(this), 3000);

    })
  }

}
export class finalFormdata {
  areaOfImpactIds: number[];
  bpgIds: number[];
  //demographic code comment
  //demographicIds: number[];
  isLeadershipChecked: leadershipFormObject;
  skillIds: number[];
  userId: any;
  otherSkill: string;
  virtualMembership: boolean;
  siteId: number;
  selectedBpg : any;
}
export class leadershipFormObject {
  isChair: boolean;
  isCommunicationChair: boolean;
  isFinanceChair: boolean;
  isViceChair: boolean;
}
